import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Chip, useAuth, useLoginRequiredModal, useT } from '@repo/common';
import MyResumeCard from './MyResumeCard';

const MyResumes = ({ onStandardSuccess, onDeleteSuccess }) => {
  const t = useT();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { showLoginModal } = useLoginRequiredModal();

  const handleSeeAll = () => {
    if (!isLoggedIn) {
      showLoginModal('career_cta');
      return;
    }
    navigate('/mypage/resumes/all');
  };

  return (
    <div className='w-full flex flex-col items-center px-4 pt-[30px] pb-10 tabletH:p-20 tabletH:pt-0 gap-6'>
      <div className='w-full max-w-[1166px] flex flex-col items-start p-0 gap-3 tabletH:gap-6'>
        <div className='typo-b18Strong tabletH:typo-h7 w-full flex flex-row justify-between items-center p-0 gap-3'>
          {t('My Resumes', '내 이력서')}
          <div>
            <Chip
              type='fill'
              size='m'
              bgclass='h-[23px] tabletH:h-[26px] py-1 px-2 tabletH:py-2 tabletH:px-3'
              hoverclass='hover:bg-grayscale-gray03'
              hideIcon
              onClick={handleSeeAll}
              borderclass='ring-0'
            >
              {t('See all', '전체 보기')}
            </Chip>
          </div>
        </div>
        <div className='w-full'>
          <MyResumeCard
            onStandardSuccess={onStandardSuccess}
            onDeleteSuccess={onDeleteSuccess}
            isCareerPage={true}
          />
        </div>
      </div>
    </div>
  );
};

export default MyResumes;
